import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import { bannerApi } from '../api';
import { bannerKeys } from './banner.keys';

export function useDeleteBanner(
  options?: UseMutationOptions<{ id: string; deletedAt: string }, Error, string>
) {
  const queryClient = useQueryClient();
  const { onSuccess: providedOnSuccess, onError: providedOnError, ...mutationOptions } = options ?? {};
  const mutation = useMutation({
    mutationKey: ['banners', 'delete'],
    mutationFn: bannerApi.remove,
    ...mutationOptions,
    onSuccess: (response, variables, onMutateResult, context) => {
      toast({ title: 'Banner excluído com sucesso', variant: 'success' });
      queryClient.invalidateQueries({ queryKey: bannerKeys.all });
      providedOnSuccess?.(response, variables, onMutateResult, context);
    },
    onError: (error, variables, onMutateResult, context) => {
      toast({
        title: 'Erro ao excluir banner',
        description: error.message,
        variant: 'destructive',
      });
      providedOnError?.(error, variables, onMutateResult, context);
    },
  });
  const deleteBanner = (bannerId: string) => mutation.mutateAsync(bannerId);
  return {
    deleteBanner,
    isLoading: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
    mutationResult: mutation,
  };
}
